// Contentsquare documentation: https://docs.contentsquare.com/en/web/sending-dynamic-vars/
const pushToContentsquare = function (key, info) {
  if (window._uxa) {
    // If _uxa is available, push directly
    window._uxa.push([key, info]);
    return;
  }

  // If window._uxa is not available, we need to check if we have a queue
  // Create a queue if it doesn't exist
  if (!window._uxaQueue) {
    window._uxaQueue = [];

    // Set up a watcher to process the queue when _uxa becomes available
    const checkForUxa = setInterval(() => {
      if (window._uxa) {
        // Process all queued items
        while (window._uxaQueue.length > 0) {
          const queuedItem = window._uxaQueue.shift();
          window._uxa.push(queuedItem);
        }
        // Clear the interval once we've processed the queue
        clearInterval(checkForUxa);
      }
    }, 100); // Check every 100ms
  }

  // Add the current call to the queue
  window._uxaQueue.push([key, info]);
}

const pushDynamicVariable = function (info) {
  pushToContentsquare('trackDynamicVariable', info);
}

const pushDestinationSearch = function (value) {
  pushToContentsquare('trackDynamicVariable', {key: 'Destination - Search Box Country', value: value})
}

const pushBenefits = function (value) {
  pushToContentsquare('trackDynamicVariable', { key: 'Hotel Page - benefits wrapper', value })
}

const pushCheckoutVariation = function (value) {
  pushToContentsquare('trackDynamicVariable', {key: 'Checkout - New design', value: value})
}

export {
  pushDynamicVariable,
  pushDestinationSearch,
  pushBenefits,
  pushCheckoutVariation,
}

export default pushToContentsquare;
